export default "__VITE_ASSET__a94bb743__"